import { useContext, useEffect, useState } from "react";
import moment from "moment";
import QAManager from "../../../../Managers/webinar/qa";
import LoaderImg from "../../../../assets/images/Loader.gif";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";

import styles from "./index.module.scss";
import { QA_TYPE } from "../../../../AppConstants/TypeConstants";
import { AnalyticsContext } from "../../../../contexts/Analytics/AnalyticsContextProvider";
import { QNA_INTERATCION } from "../../../../AppConstants/AnalyticsEventName";
import { scrollToBottom, showToast } from "../../../../utils/common.utils";
import { POLL_STATES } from "../../../../AppConstants/PollStates";
import { QNA_SUBMIT_EVENT } from "../../../../Clevertap/EventNames.ts";
import { getWebinarClickData } from "../../../../Clevertap/EventHandler.ts";

function QnA({ ques = [], webinarID, details, moderatedQNA }) {
  const { addGAWithUserInfo, addCleverTapAnalytics } =
    useContext(AnalyticsContext);
  const { ongoingagendaid } = details;

  const { user } = useContext(UserContext);
  const [inputVal, setInputVal] = useState("");

  useEffect(() => {
    // scroll to bottom
    scrollToBottom("qna-Container");
  }, [ques]);

  const handleInput = async (e) => {
    e.preventDefault();
    let obj = {
      index: 0,
      question: inputVal,
      webinarId: webinarID,
      agendaId: ongoingagendaid || null,
      type: QA_TYPE.MAINTHREAD,
      userId: user.uid,
      name: user.displayName,
      status: !moderatedQNA ? POLL_STATES.showQuestion : POLL_STATES.hide,
    };

    addCleverTapAnalytics(QNA_SUBMIT_EVENT, {
      Content: inputVal,
      ...getWebinarClickData(details),
    });
    await QAManager._post.createQA(obj);
    if (moderatedQNA) {
      showToast("Your question is under moderation");
    }
    QNASendAnalytics();
    setInputVal("");

    // scroll to bottom
    scrollToBottom("qna-Container");
  };

  const QNASendAnalytics = () => {
    if (ongoingagendaid) {
      addGAWithUserInfo(QNA_INTERATCION, {
        eventId: webinarID,
        timelineId: ongoingagendaid,
      });
    } else {
      addGAWithUserInfo(QNA_INTERATCION, { eventId: webinarID });
    }
  };

  return (
    <div className={styles.qnaWrapper}>
      <div id="qna-Container" className={styles.qcontainer}>
        {!ques && (
          <div className={styles.loader}>
            <img src={LoaderImg} alt="loading..." />
          </div>
        )}
        {ques &&
          ques.map((ques, key) => {
            return (
              <div key={key} className={styles.quesCard}>
                <div className={styles.row}>
                  <div>{ques.name}</div>
                  <div>
                    {moment(ques.timestamp.toDate().toUTCString()).format(
                      "hh:mm A"
                    )}
                  </div>
                </div>
                <div>{ques.question}</div>
              </div>
            );
          })}
      </div>
      <form className={styles.input} onSubmit={handleInput}>
        <input
          id="inputBox"
          type="text"
          placeholder="Ask a question"
          value={inputVal}
          onChange={(e) => {
            setInputVal(e.target.value);
          }}
          autoComplete="off"
        />
        <button disabled={!inputVal.length}>Send</button>
      </form>
    </div>
  );
}

export default QnA;
